import { motion } from 'framer-motion';
import { ArrowRight, Scale, Ruler, Wrench, RotateCw, Settings } from 'lucide-react';

const TechnicalDetails = () => {
  return (
    <div className="pt-24 min-h-screen">
      <div className="container-section">
        <motion.div 
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title text-center mb-12">Technické detaily</h1>
          
          {/* Technical specifications */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-12">
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start">
                <Scale className="text-tech-blue mr-4 mt-1" size={24} />
                <div>
                  <h3 className="text-lg font-bold mb-2">Hmotnost a rozměry</h3>
                  <ul className="space-y-2 text-foreground/80">
                    <li><span className="font-medium">Celková hmotnost:</span> 2 kg</li>
                    <li><span className="font-medium">Rozměry (D×Š×V):</span> 150 × 148 × 30 mm</li>
                    <li><span className="font-medium">Max. rozevření čelistí:</span> 30 mm</li>
                    <li><span className="font-medium">Výška čelistí:</span> 24 mm</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start">
                <Ruler className="text-tech-blue mr-4 mt-1" size={24} />
                <div>
                  <h3 className="text-lg font-bold mb-2">Materiály</h3>
                  <ul className="space-y-2 text-foreground/80">
                    <li><span className="font-medium">Tělo:</span> PTA filament 5mm stěna</li>
                    <li><span className="font-medium">Čelisti:</span> PTA + PETG</li>
                    <li><span className="font-medium">Šrouby:</span> M4 x 40 mm, M4 x 20 mm</li>
                    <li><span className="font-medium">Výstuž:</span> Gumová o průměru 6 mm</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start">
                <Wrench className="text-tech-blue mr-4 mt-1" size={24} />
                <div>
                  <h3 className="text-lg font-bold mb-2">Výrobní proces</h3>
                  <ul className="space-y-2 text-foreground/80">
                    <li><span className="font-medium">Hlavní tělo:</span> 3D tisk (PTA)</li>
                    <li><span className="font-medium">Vnitřní výplň:</span> Beton</li>
                    <li><span className="font-medium">Čelisti:</span> 3D tisk (PTA/PETG)</li>
                    <li><span className="font-medium">Spojovací prvky:</span> Standardní metrické</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start">
                <RotateCw className="text-tech-blue mr-4 mt-1" size={24} />
                <div>
                  <h3 className="text-lg font-bold mb-2">Pohyblivé mechanismy</h3>
                  <ul className="space-y-2 text-foreground/80">
                    <li><span className="font-medium">Hlavní pohybový šroub:</span> M4</li>
                    <li><span className="font-medium">Otočný mechanismus:</span> Standardní</li>
                    <li><span className="font-medium">Rozsah otáčení:</span> 0–180°</li>
                    <li><span className="font-medium">Aretace:</span> Manuální</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start">
                <Settings className="text-tech-blue mr-4 mt-1" size={24} />
                <div>
                  <h3 className="text-lg font-bold mb-2">Speciální funkce</h3>
                  <ul className="space-y-2 text-foreground/80">
                    <li><span className="font-medium">Vyměnitelné čelisti:</span> Různé typy</li>
                    <li><span className="font-medium">Otočná základna:</span> Ano</li>
                    <li><span className="font-medium">Betonový základ:</span> Pro stabilitu</li>
                    <li><span className="font-medium">Montážní otvory:</span> Standardní</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              className="tech-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div>
                <h3 className="text-lg font-bold mb-2">Praktické využití</h3>
                <ul className="space-y-2 text-foreground/80">
                  <li><span className="font-medium">Školní projekty:</span> Ideální pro výuku</li>
                  <li><span className="font-medium">Domácí dílna:</span> Kompaktní a univerzální</li>
                  <li><span className="font-medium">Elektronika:</span> Jemná práce</li>
                  <li><span className="font-medium">Prototypování:</span> Rychlé upnutí dílů</li>
                </ul>
              </div>
            </motion.div>
          </div>
          
          {/* Technical diagram section */}
          <motion.div 
            className="mt-16"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl font-bold mb-6 text-center">Schématické znázornění</h2>
            
            <div className="bg-tech-dark/50 border border-tech-charcoal/30 rounded-lg p-6 flex flex-col items-center justify-center">
              <img 
                src="/lovable-uploads/cbf97b82-d99b-4785-9aaf-f20687b16e07.png"
                alt="Schéma svěráku V3DSTUDIO"
                className="max-w-full h-auto rounded-lg shadow-lg"
              />
              <p className="text-sm text-foreground/60 mt-4">Technický výkres svěráku MP 101</p>
            </div>
            
            <div className="mt-8 text-center">
              <a href="/downloads" className="btn-primary inline-flex">
                Stáhnout technickou dokumentaci <ArrowRight size={18} />
              </a>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default TechnicalDetails;
